// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cache from "../data/Cache.bs.js";
import * as React from "react";
import * as Tc2List from "./Tc2List.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as TcHeader from "../team-comps/TcHeader.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";

function Tc2Page(Props) {
  var initialData = Props.initialData;
  var aperture = ApertureCtx.useValue(undefined);
  var data = Cache.useComps(initialData, aperture.queue);
  var match = React.useState(function () {
        return /* Place */1;
      });
  var sortOrder = match[0];
  var match$1 = React.useState(function () {
        return [];
      });
  var filters = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var hideLowPlayrates = match$2[0];
  var match$3 = React.useState(function () {
        return true;
      });
  var showAugComps = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var expandSubcomps = match$4[0];
  var tmp;
  if (data !== undefined && data[0] === aperture.queue) {
    var comps = data[1];
    tmp = React.createElement("div", {
          className: "flex flex-col items-center w-screen " + "md:w-[868px] xl:w-[956px]"
        }, React.createElement(TcHeader.make, {
              globalAvgPlace: comps.place,
              filters: filters,
              setFilters: match$1[1],
              sortOrder: sortOrder,
              setSortOrder: match[1],
              hideLowPlayrates: hideLowPlayrates,
              setHideLowPlayrates: match$2[1],
              expandSubcomps: expandSubcomps,
              setExpandSubcomps: match$4[1],
              showAugComps: showAugComps,
              setShowAugComps: match$3[1]
            }), React.createElement(Tc2List.make, {
              groups: comps.groups,
              globalCount: comps.count,
              filters: filters,
              fullDataLoaded: comps !== initialData,
              expandSubcomps: expandSubcomps,
              hideLowPlayrates: hideLowPlayrates,
              sortOrder: sortOrder,
              showAugComps: showAugComps
            }));
  } else {
    tmp = null;
  }
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: tmp
                }));
}

var make = Tc2Page;

export {
  make ,
  
}
/* Cache Not a pure module */
